import { createSlice } from "@reduxjs/toolkit";

const stoneAttrSlice = createSlice({
    name:"stoneAttr",
    initialState:{
        stoneAttr:null
    },
    reducers:{
        setStoneAttrList(state,action){
            state.stoneAttr = action?.payload;
        },
    }
})


export const {setStoneAttrList} = stoneAttrSlice.actions
export default stoneAttrSlice.reducer